module.exports = __webpack_public_path__ + "img/139.8e8fc70c.png";